import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import NdbkAPI from '../ndbk-api'
import LoginForm from '../components/LoginForm'
import SignUpForm from '../components/SignUpForm'
import {
    Dialog, Tooltip, Position, Icon, Popover, PopoverInteractionKind, Button
} from "@blueprintjs/core";

class MainNav extends React.Component {
    state = {
        isLoginFormOpen: false,
        isSignupFormOpen: false
    }

    setLoginFormOpen = (isOpen) => {
        this.setState({ isLoginFormOpen: isOpen })
    }

    logoutHandler = () => {
        NdbkAPI.auth.logout(() => {
            this.props.auth.checkAuth(() => {
                this.props.history.push('/landing')
            })
        })
    }

    setSignupFormOpen = (val) => {
        this.setState({ isSignupFormOpen: val })
    }

    componentWillMount = () => {
        this.isMobile = (window.orientation === undefined) ? false : true;
    }

    render() {

        const extraOptions = (
            <div className="extra">
                {/*<a onClick={this.logoutHandler}>Help</a>*/}
                <Button minimal className="button" large onClick={() => { this.setSignupFormOpen(true) }} icon="new-person">Sign up</Button>
            </div>
        )

        const extraOptions2 = (
            <div className="extra">
                {/*<a onClick={this.logoutHandler}>Help</a>*/}
                <Button minimal className="button" large onClick={this.logoutHandler} icon="log-out">Log out</Button>
            </div>
        )

        return (
            <div>
                <div>

                    <Dialog
                        isOpen={this.state.isLoginFormOpen}
                        onClose={() => { this.setLoginFormOpen(false) }}
                        title="Sign In"
                        icon="log-in"
                    >
                        <LoginForm {...this.props} />
                    </Dialog>

                    <Dialog
                        isOpen={this.state.isSignupFormOpen}
                        onClose={() => { this.setSignupFormOpen(false) }}
                        title="Create account"
                        icon="new-person"
                    >
                        <SignUpForm />
                    </Dialog>

                    <div className="landing-header">
                        <h1 className="landing-logo" onClick={() => { this.props.history.push('/landing') }}><span className="bd"><span>node</span></span>book</h1>
                        <nav className="landing-controls">
                            <Link to="/donate">Donate</Link>
                            {/* <Link to="/features">Features</Link> */}
                            {/*<Link to="/pricing">Pricing</Link>*/}
                            {/* <Link to="/roadmap">Roadmap</Link>
                            <Link to="/blog">Blog</Link> */}
                            {
                                (this.props.auth.success === false || (this.props.auth.success && this.props.auth.user.isGuest === true))
                                    ? (
                                        <React.Fragment>
                                            <a onClick={() => { this.setSignupFormOpen(true) }}>Sign Up</a>
                                            <a onClick={() => { this.setLoginFormOpen(true) }}>Sign In</a>
                                            {/* // <Popover
                                        //     minimal
                                        //     usePortal={false}
                                        //     key="signup_pop"
                                        //     content={extraOptions}
                                        //     position={Position.BOTTOM_RIGHT}
                                        //     interactionKind={PopoverInteractionKind.CLICK}
                                        // >
                                        //     <Button minimal icon="chevron-down" style={{marginLeft: "6px"}}/>
                                        // </Popover> */}
                                        </React.Fragment>
                                    )
                                    : (
                                        <Link key="dashboard" to="/">Go to App</Link>
                                        /* // <Popover
                                        //     minimal
                                        //     usePortal={false}
                                        //     key="logout_pop"
                                        //     content={extraOptions2}
                                        //     position={Position.BOTTOM_RIGHT}
                                        //     interactionKind={PopoverInteractionKind.CLICK}
                                        // >
                                        //     <Button minimal icon="chevron-down" style={{marginLeft: "6px"}}/>
                                        // </Popover> */
                                    )
                            }
                        </nav>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(MainNav);


// WEBPACK FOOTER //
// ./src/components/MainNav.js